import { render, staticRenderFns } from "./SupprimerRuches.vue?vue&type=template&id=8ce2f1d4&"
import script from "./SupprimerRuches.vue?vue&type=script&lang=js&"
export * from "./SupprimerRuches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports